import logoUrl from '../iconosFoodPlan/food-logo.jpg'

/** Logo oficial FOOD PLAN (F ribbon + verde; fuente `food-logo.jpg` / IMG_5406). No manzana. */
export default function AppLogo({
  size = 32,
  className = '',
}: {
  size?: number
  className?: string
}) {
  const fluid = /\bw-full\b/.test(className)
  return (
    <img
      src={logoUrl}
      alt="Food Plan"
      width={fluid ? undefined : size}
      height={fluid ? undefined : size}
      className={className}
      style={{
        objectFit: 'contain',
        borderRadius: size >= 40 || fluid ? 8 : 4,
        display: 'block',
        ...(fluid ? { width: '100%', height: 'auto' } : null),
      }}
    />
  )
}
